import { ScrollPosition } from 'react-lazy-load-image-component';
import { messageComponents, MessageType } from '../../common/chat/tools';
import { GroupedMessage, RoomStageInfo } from '../../common/types';

export type RenderedGroupMessageProps = {
  message: GroupedMessage;
  index: number;
  length: number;
  scrollPosition?: ScrollPosition;
  onLoad?: () => void;
  stages: RoomStageInfo[];
};

export default function RenderedGroupMessage(props: RenderedGroupMessageProps) {
  const { message } = props;

  const LeftComponent = messageComponents[message.left.type as MessageType];
  const leftContent = (
    <LeftComponent
      message={message.left}
      scrollPosition={props.scrollPosition}
      onLoad={props.onLoad}
      index={props.index}
      length={props.length}
    />
  );
  const RightComponent = messageComponents[message.right.type as MessageType];
  const rightContent = (
    <RightComponent
      message={message.right}
      scrollPosition={props.scrollPosition}
      onLoad={props.onLoad}
      index={props.index}
      length={props.length}
    />
  );

  return (
    <div className="space-y-4">
      {/* Container with responsive columns and padding */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex-1">{leftContent}</div>
        <div className="flex-1">{rightContent}</div>
      </div>
    </div>
  );
}
